/**
 * Process a single slider to move its navigation outside.
 *
 * @param {HTMLElement} slider - The slider element to process.
 * @return {boolean} True if processed successfully, false if buttons not found yet.
 */
function processSlider(slider) {
	// Check if this slider has navigation buttons
	const prevButton = slider.querySelector('.swiper-button-prev');
	const nextButton = slider.querySelector('.swiper-button-next');

	if (!prevButton || !nextButton) {
		return false;
	}

	// Check if already wrapped (in case this runs multiple times)
	if (slider.parentElement.classList.contains('slider-with-external-nav')) {
		return true;
	}

	// Create wrapper elements
	const wrapper = document.createElement('div');
	wrapper.className = 'slider-with-external-nav';

	const contentWrapper = document.createElement('div');
	contentWrapper.className = 'slider-content-wrapper';

	// Insert wrapper before slider
	slider.parentNode.insertBefore(wrapper, slider);

	// Move slider into content wrapper
	contentWrapper.appendChild(slider);

	// Build the structure: prev button, content wrapper, next button
	wrapper.appendChild(prevButton);
	wrapper.appendChild(contentWrapper);
	wrapper.appendChild(nextButton);

	return true;
}

/**
 * Initialize slider processing with retry logic.
 */
function initSliderProcessing() {
	const sliders = document.querySelectorAll('.wp-block-bb-block-slider');
	const unprocessedSliders = [];

	sliders.forEach((slider) => {
		if (!processSlider(slider)) {
			unprocessedSliders.push(slider);
		}
	});

	// If there are unprocessed sliders, set up a MutationObserver to watch for button additions
	if (unprocessedSliders.length > 0) {
		const observer = new MutationObserver(() => {
			const remainingSliders = unprocessedSliders.filter((slider) => !processSlider(slider));

			// If all sliders are processed, disconnect the observer
			if (remainingSliders.length === 0) {
				observer.disconnect();
			}
		});

		// Observe each unprocessed slider for child additions
		unprocessedSliders.forEach((slider) => {
			observer.observe(slider, {
				childList: true,
				subtree: true,
			});
		});

		// Also add a fallback timeout in case buttons take a while to appear
		setTimeout(() => {
			unprocessedSliders.forEach((slider) => processSlider(slider));
			observer.disconnect();
		}, 2000);
	}
}

document.addEventListener('DOMContentLoaded', initSliderProcessing);
